export type PostClass =
  | "post1000"
  | "post800"
  | "post600"
  | "post400"
  | "post300"
  | "post200"
  | "post100"
export type LogoClass = "logo" | "miniLogo" | "thumb" | "smallThumb"
export type ImageClass = PostClass | LogoClass

export function cdnClass(url: string, imageClass: ImageClass) {
  const urlObj = new URL(url)
  const params = new URLSearchParams(urlObj.search)

  params.set("class", imageClass)
  urlObj.search = params.toString()

  return urlObj.toString()
}
